import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessageBoxDialogComponent } from './message-box.dialog.component';
import { SharedModule } from '../shared.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    MatDialogModule,
    SharedModule
  ],
  declarations: [
    MessageBoxDialogComponent
  ]
})
export class MessageBoxModule { }
